import User from '@/api/models/User';
import { defineStore } from 'pinia';
import LanguageService from '@/services/LanguageService';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: null,
    performingLoggin: false,
  }),
  actions: {
    login(userData, setLanguage = true) {
      this.user = new User(userData);

      if (setLanguage && this.user.language) {
        const language = LanguageService.getLanguage(this.user.language);
        
        if (language) { 
          const { useContextStore } = require('@/stores/context');
          const contextStore = useContextStore();
          
          contextStore.setLang(language.getValue().code);
        }
      }
    },
    logout() {
      this.user = null;
    },
    updateUser(userObj) {
      this.user = userObj;
    },
    saveToken(token) {
      this.token = token;
    },
    performingLogin(isLogging = false) {
      this.performingLoggin = isLogging;
    }
  },
  getters: {
    isAuthenticated: (state) => state.user ?? false,
    checkUuid: (state) => {
      return (uuid) => state.user?.uuid === uuid;
    },
    getUser: (state) => state.user,
    isPerformingLogin: (state) => state.performingLoggin,
    isAdmin: (state) => state.user?.isAdmin() ?? false,
    getUserId: (state) => state.user?.id ?? null,
  }
})
